module.exports = __webpack_public_path__ + "img/honor-fallen-heroes.jpg";